import React from 'react'

const Retouch = ({ className }) => {
  return (
    <svg
      width={22}
      height={21}
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="9.65918"
        y="7.95117"
        width={12}
        height={2}
        transform="rotate(41.0841 9.65918 7.95117)"
        fill="white"
      />
      <rect
        x="6.64453"
        y="5.32227"
        width={2}
        height={2}
        transform="rotate(41.0841 6.64453 5.32227)"
        fill="white"
      />
      <path
        d="M7.88775 3.96136L8.65234 2.11328"
        stroke="white"
        strokeLinecap="round"
      />
      <path
        d="M5.10155 4.22097L4.00879 2.5459"
        stroke="white"
        strokeLinecap="round"
      />
      <path
        d="M9.73072 6.48168L11.7236 6.31348"
        stroke="white"
        strokeLinecap="round"
      />
      <path
        d="M4.82916 11.3539L5.21146 10.4299L5.59375 9.50586"
        stroke="white"
        strokeLinecap="round"
      />
      <path
        d="M1.75806 7.15453L2.75452 7.07043L3.75098 6.98633"
        stroke="white"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default Retouch
